import { render, staticRenderFns } from "./ComparativoVendas.vue?vue&type=template&id=4f599a8e&scoped=true"
import script from "./ComparativoVendas.vue?vue&type=script&lang=js"
export * from "./ComparativoVendas.vue?vue&type=script&lang=js"
import style0 from "./ComparativoVendas.vue?vue&type=style&index=0&id=4f599a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f599a8e",
  null
  
)

export default component.exports